import React from 'react';
import { CheckCircleIcon, XCircleIcon, AlertCircleIcon, ClockIcon, LockIcon } from 'lucide-react';
type StatusType = 'success' | 'error' | 'warning' | 'pending' | 'locked' | 'info';
interface StatusBadgeProps {
  status: StatusType;
  label: string;
  size?: 'sm' | 'md';
  showIcon?: boolean;
}
const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  label,
  size = 'sm',
  showIcon = true
}) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'success':
        return {
          bg: 'bg-green-100',
          text: 'text-green-800',
          icon: <CheckCircleIcon className="h-3.5 w-3.5 text-green-500 mr-1" data-id="element-61" />
        };
      case 'error':
        return {
          bg: 'bg-red-100',
          text: 'text-red-800',
          icon: <XCircleIcon className="h-3.5 w-3.5 text-red-500 mr-1" data-id="element-62" />
        };
      case 'warning':
        return {
          bg: 'bg-yellow-100',
          text: 'text-yellow-800',
          icon: <AlertCircleIcon className="h-3.5 w-3.5 text-yellow-500 mr-1" data-id="element-63" />
        };
      case 'pending':
        return {
          bg: 'bg-blue-100',
          text: 'text-blue-800',
          icon: <ClockIcon className="h-3.5 w-3.5 text-blue-500 mr-1" data-id="element-64" />
        };
      case 'locked':
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          icon: <LockIcon className="h-3.5 w-3.5 text-gray-500 mr-1" data-id="element-65" />
        };
      case 'info':
      default:
        return {
          bg: 'bg-blue-100',
          text: 'text-blue-800',
          icon: <AlertCircleIcon className="h-3.5 w-3.5 text-blue-500 mr-1" data-id="element-66" />
        };
    }
  };
  const {
    bg,
    text,
    icon
  } = getStatusStyles();
  const sizeClasses = size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-sm';
  return <span className={`inline-flex items-center rounded-full ${bg} ${text} ${sizeClasses} font-medium`} data-id="element-67">
      {showIcon && icon}
      {label}
    </span>;
};
export default StatusBadge;